"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageLayoutStylesContext = void 0;
const react_1 = require("react");
exports.PageLayoutStylesContext = (0, react_1.createContext)(undefined);
